module.exports = __webpack_public_path__ + "static/media/autoImmune-account-number.bdd2ed7c.png";